import { T } from '@tribeplatform/react-components/i18n'
import { SectionHeader } from '@tribeplatform/react-ui-kit/SectionHeader'

export const BillingHeader = () => (
  <SectionHeader
    title={
      <h1 className="text-heading-md font-bold text-content">
        <T
          defaultMessage="Subscription summary"
          id="Admin.Billing.SubscriptionSummary"
        />
      </h1>
    }
    description={
      <p className="text-md text-content-muted">
        <T
          defaultMessage="Overview and adjust your plan details, add-on services, and billing preferences."
          id="Admin.Billing.BillingDescription"
        />
      </p>
    }
  />
)
